<template>
  <transition name="modal">
    <div v-if="open" class="modal" role="dialog" aria-modal="true" @click.self="$emit('close')" @keydown.esc="$emit('close')">
      <div class="modal__box corners">
        <button class="modal__x" @click="$emit('close')" :aria-label="c.emergency.close">×</button>
        <p class="eyebrow">SOS</p>
        <h3 class="modal__title">{{ c.emergency.title }}</h3>
        <p class="modal__text">{{ c.emergency.text }}</p>
        <ol class="modal__steps">
          <li v-for="(s, i) in c.emergency.steps" :key="i"><span>0{{ i + 1 }}</span>{{ s }}</li>
        </ol>
        <div class="modal__contact">
          <div class="modal__btns">
            <a class="btn btn--primary" :href="TELEGRAM_URL" target="_blank" rel="noopener" @click="track('click_telegram', { from: 'emergency' })">{{ c.emergency.telegram }} · {{ TELEGRAM_HANDLE }}</a>
            <a class="btn btn--ghost" :href="mailto">{{ c.emergency.email }} · {{ CONTACT_EMAIL }}</a>
          </div>
          <div class="modal__qr">
            <img src="@/assets/weChat.png" alt="WeChat QR">
            <span>{{ c.emergency.wechat }}</span>
            <WechatId dark />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed, watch } from 'vue'
import { content as c, CONTACT_EMAIL, TELEGRAM_HANDLE, TELEGRAM_URL } from '@/i18n'
import { track } from '@/track'
import WechatId from '@/components/WechatId.vue'

const props = defineProps({ open: Boolean })
const emit = defineEmits(['close'])

const mailto = computed(() => `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(c.value.emergency.subject)}`)

function onKey(e) { if (e.key === 'Escape') emit('close') }
watch(() => props.open, v => {
  document.body.style.overflow = v ? 'hidden' : ''
  if (v) window.addEventListener('keydown', onKey)
  else window.removeEventListener('keydown', onKey)
})
</script>

<style scoped>
.modal { position: fixed; inset: 0; z-index: 400; background: rgba(0,0,0,.72); display: grid; place-items: center; padding: 16px; backdrop-filter: blur(6px); -webkit-backdrop-filter: blur(6px); }
.modal__box { position: relative; width: min(560px, 100%); max-height: 92vh; overflow: auto; background: var(--ink-2); padding: 40px; color: var(--ink-text); }
.modal__x { position: absolute; top: 12px; right: 16px; font-size: 28px; color: var(--ink-muted); line-height: 1; }
.modal__x:hover { color: var(--ink-text); }
.modal__title { font-family: var(--font-display); font-size: 32px; line-height: 1.2; }
.modal__text { color: var(--ink-muted); margin-top: 10px; }
.modal__steps { list-style: none; margin: 22px 0 28px; display: grid; gap: 10px; }
.modal__steps li { display: flex; gap: 14px; padding: 14px 16px; background: rgba(255,255,255,.03); border: 1px solid var(--ink-line); font-size: 15px; }
.modal__steps span { font-family: var(--font-mono); color: var(--danger); }
.modal__contact { display: flex; gap: 20px; align-items: center; flex-wrap: wrap; }
.modal__btns { flex: 1; min-width: 240px; display: grid; gap: 10px; }
.modal__contact .btn { width: 100%; text-transform: none; letter-spacing: .04em; }
.modal__qr { display: flex; flex-direction: column; align-items: center; gap: 6px; font-size: 12px; color: var(--ink-muted); }
.modal__qr img { width: 96px; height: 96px; background: #fff; padding: 4px; }
.modal-enter-active, .modal-leave-active { transition: opacity .25s; }
.modal-enter-from, .modal-leave-to { opacity: 0; }
@media (max-width: 600px) { .modal__box { padding: 28px 20px; } .modal__title { font-size: 26px; } }
</style>
